module.exports = __webpack_public_path__ + "static/media/applePay.41e42cb2.svg";